import api from "../services/api";

function toQueryString(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, rawValue] of Object.entries(filters || {})) {
    if (rawValue === undefined || rawValue === null || rawValue === "") continue;
    params.set(key, String(rawValue));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export async function getFormTemplates(filters = {}) {
  const res = await api.get(`/form-templates${toQueryString(filters)}`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function getFormTemplate(id) {
  const res = await api.get(`/form-templates/${id}`);
  return res.data;
}

export async function getFormTemplateVersions(templateId) {
  const res = await api.get(`/form-templates/${templateId}/versions`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createFormTemplate(payload) {
  const res = await api.post("/form-templates", payload);
  return res.data;
}

export async function updateFormTemplate(templateId, payload) {
  const res = await api.patch(`/form-templates/${templateId}`, payload);
  return res.data;
}

export async function createFormTemplateVersion(templateId, payload) {
  const res = await api.post(`/form-templates/${templateId}/versions`, payload);
  return res.data;
}

export async function publishFormTemplateVersion(versionId) {
  const res = await api.post(`/form-template-versions/${versionId}/publish`);
  return res.data;
}

export async function submitForm(payload) {
  const res = await api.post("/forms/submit", payload);
  return res.data;
}
